import { MonitorPlay, Users, CalendarDays, ArrowUpRight } from "lucide-react";
import { formatUSD, formatDate } from "../lib/api";

export default function MaestriaCard({ maestria, index = 0 }) {
    const cohorte = maestria?.cohortes_inscripcion_abierta?.[0];
    const isOnline = (maestria.modalidad || "").toUpperCase().includes("LÍNEA") ||
                     (maestria.modalidad || "").toUpperCase().includes("LINEA");
    const ModIcon = isOnline ? MonitorPlay : Users;
    
    // El usuario solicitó que todas las tarjetas redirijan a la página principal de maestrías
    const unemiUrl = "https://www.unemi.edu.ec/index.php/maestrias/";

    return (
        <a
            href={unemiUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`maestria-card-${maestria.pk}`}
            style={{ animationDelay: `${index * 60}ms` }}
            className="opacity-0 animate-fade-up bg-white border border-slate-200 rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:shadow-unemi-blue-primary/10 hover:border-unemi-blue-light/40 group flex flex-col h-full"
        >
            <div className="flex items-start justify-between gap-3 mb-5">
                <span className="inline-flex items-center gap-1.5 bg-unemi-orange-primary/10 text-unemi-orange-primary font-bold px-3 py-1 rounded-full text-[10px] uppercase tracking-wider">
                    <span className="w-1.5 h-1.5 rounded-full bg-unemi-orange-primary animate-pulse" />
                    Inscripción abierta
                </span>
                <span className="inline-flex items-center gap-1 bg-slate-100 text-slate-600 px-2.5 py-1 rounded-full text-[10px] font-semibold">
                    <ModIcon className="w-3 h-3" />
                    {maestria.modalidad}
                </span>
            </div>

            <h3 className="font-heading text-lg leading-snug text-unemi-blue-dark group-hover:text-unemi-blue-primary transition-colors line-clamp-3 min-h-[4.5rem]">
                {maestria.nombre_maestria}
            </h3>

            <div className="mt-5 pt-5 border-t border-slate-100 space-y-2.5 text-sm">
                <div className="flex items-center justify-between text-slate-600">
                    <span className="text-xs uppercase tracking-wider text-slate-400 font-bold">
                        Cohorte
                    </span>
                    <span className="font-semibold text-slate-700">
                        {cohorte?.cohorte || "—"}
                    </span>
                </div>
                <div className="flex items-center justify-between text-slate-600">
                    <span className="text-xs uppercase tracking-wider text-slate-400 font-bold flex items-center gap-1">
                        <CalendarDays className="w-3 h-3" /> Cierre
                    </span>
                    <span className="font-semibold text-slate-700">
                        {formatDate(cohorte?.fecha_fin_inscripcion)}
                    </span>
                </div>
            </div>

            <div className="mt-6 flex items-end justify-between">
                <div>
                    <p className="text-[10px] uppercase tracking-wider font-bold text-slate-400">
                        Inversión
                    </p>
                    <p className="font-heading text-2xl font-semibold text-unemi-blue-dark tabular-nums">
                        {formatUSD(cohorte?.valor_programa)}
                    </p>
                </div>
                <span className="grid place-items-center w-11 h-11 rounded-full bg-unemi-blue-primary text-white group-hover:bg-unemi-orange-primary group-hover:rotate-45 transition-all">
                    <ArrowUpRight className="w-4 h-4" />
                </span>
            </div>
        </a>
    );
}
